<app-modal id="news">
  <div class="modal-content">
    <p class="title"><img src="/assets/images/home/news.svg" alt="icone nouveautés" width="47" height="46">nouveautés
    </p>
    <div class="bloc-news">
      <div class="news-date">
        30 MARS 2023
      </div>
      <div class="news-titre">
        <img src="/assets/images/home/picture.svg" alt="Icone MONETISATION" width="39" height="36"> MONETISATION DES
        RECETTES
      </div>
      <div class="news-texte">
        Nous sommes ravis d'annoncer une fonctionnalité majeure, désormais, les créateurs pourront <b>choisir</b> de
        monétiser leurs recettes avec des publicités. La monétisation récompensera l'investissement des créateurs et
        aidera au développement de Tooda.
        Retrouvez plus d'infos sur la monétisation : <br/><br/>
          <a [routerLink]="'information-monetisation'" (click)="closeModal('news')" class="btn btn-raised-main" href="">Le guide de la monétisation</a>
      </div>
      <div class="divider"></div>
    </div>
    <div class="bloc-news">
      <div class="news-date">
        05 DECEMBRE 2022
      </div>
      <div class="news-titre">
        <img src="/assets/images/home/picture.svg" alt="Icone GENERATEUR DE PHOTOS RECETTE" width="39" height="36">
        GENERATEUR DE PHOTOS RECETTE
      </div>
      <div class="news-texte">
        Vous pouvez désormais ajouter une photo libre de droits via des sites spécialisés (Pixabay et Pexel) directement
        dans la création de recette. Cependant nous vous recommandons d’utiliser vos propres photos pour de meilleures
        indications !
      </div>
      <div class="divider"></div>
    </div>
    <div class="bloc-news">
      <div class="news-date">
        03 DECEMBRE 2022
      </div>
      <div class="news-titre">
        <img src="/assets/images/home/dashboard.svg" alt="Icone TABLEAU DE BORD" width="39" height="36"> TABLEAU DE BORD
      </div>
      <div class="news-texte">
        Le tableau de bord est en ligne ! Retrouvez toutes les informations et statistiques de votre profil et vos recettes en un seul endroit.
      </div>
      <div class="divider"></div>
    </div>
    <div class="bloc-news">
      <div class="news-date">
         15 JUILLET 2022
      </div>
      <div class="news-titre">
        <img src="/assets/images/home/conversation.svg" alt="Icone DISCUSSION INSTANTANEE" width="39" height="36"> DISCUSSION INSTANTANEE
      </div>
      <div class="news-texte">
        Vous pouvez désormais discuter en direct avec les membres de Tooda sans restriction, demandez des conseils, partager vos résultats, créer des liens avec vos artistes préférées :)
      </div>
      <div class="divider"></div>
    </div>
    <div class="bloc-news">
      <div class="news-date">
        18 AOUT 2022
      </div>
      <div class="news-titre">
        <img src="/assets/images/home/ingredients.svg" alt="Icones ingrédients" width="45" height="45"> Repertoire des ingrédients
      </div>
      <div class="news-texte">
        Vous ne connaissez pas un ingrédient ? vous aimeriez savoir ou vous en procurer ?
        Tooda permet désormais d'avoir les informations essentielles d'un produit, en cliquant sur l'icone à côté de la barre de recherche ou directement sur un ingrédient dans une recette.
      </div>
      <div class="divider"></div>
    </div>
    <div class="bloc-news">
      <div class="news-date">
        12 SEPTEMBRE 2022
      </div>
      <div class="news-titre">
        <img src="/assets/images/home/videos.svg" alt="Icone vidéo" width="42" height="29"> AJOUTE DES VIDEOS à tes RECETTES
      </div>
      <div class="news-texte">
        C'est chose faite ! Vous pouvez désormais importer vos propres vidéos dans vos recettes, détaillés vos processus de création de vos recettes !
      </div>
    </div>
  </div>
  <div class="modal-btn">
    <button class="btn btn-raised-main" (click)="closeModal('news');">Compris, merci</button>
  </div>
</app-modal>

<div class="home">

  <button class="btn news" (click)="openModal('news')">
    <img src="/assets/images/home/news.svg" alt="Bouton nouveautés" width="47" height="46">
    <span class="show-text-news {{classNews}}">MONETISATION</span>
    <img src="/assets/images/home/news-red.svg" class="news-red" width="62" height="29" alt="Bouton nouveautés">
  </button>

  <picture>
    <source srcset="/assets/images/home/bg-home-tooda-rigth.webp?v=2.3" type="image/webp">
    <source srcset="/assets/images/home/bg-home-tooda-rigth.png?v=2.3" type="image/png">
    <img src="/assets/images/home/bg-home-tooda-rigth.webp?v=2.3" class="home-bg-right" alt="Background accueil droite" loading="eager" height="1039" width="1923">
  </picture>

  <picture>
    <source srcset="/assets/images/home/bg-home-tooda-mobile.webp?v=2.3" type="image/webp">
    <source srcset="/assets/images/home/bg-home-tooda-mobile.png?v=2.3" type="image/png">
    <img ngSrc="/assets/images/home/bg-home-tooda-mobile.webp?v=2.3" class="home-bg-mobile" width="980" loading="lazy" height="592"
         alt="Background accueil mobile">
  </picture>

  <div class="text-intro-tooda">
    <div class="icon-1">
      <picture>
        <source srcset="/assets/images/home/icon/couture.webp?v=2.3" type="image/webp">
        <source srcset="/assets/images/home/icon/couture.png?v=2.3" type="image/png">
        <img src="/assets/images/home/icon/couture.webp?v=2.3" class="gravity gravity-1" alt="Icone couture" loading="lazy" height="22" width="17">
      </picture>
      <picture>
        <source srcset="/assets/images/home/icon/couture_shadow.webp?v=2.3" type="image/webp">
        <source srcset="/assets/images/home/icon/couture_shadow.png?v=2.3" type="image/png">
        <img src="/assets/images/home/icon/couture_shadow.webp?v=2.3" alt="Icone ombre couture" loading="lazy" height="26" width="20">
      </picture>
    </div>
    <div class="icon-2">
      <picture>
        <source srcset="/assets/images/home/icon/cosmetique.webp?v=2.3" type="image/webp">
        <source srcset="/assets/images/home/icon/cosmetique.png?v=2.3" type="image/png">
        <img src="/assets/images/home/icon/cosmetique.webp?v=2.3" class="gravity gravity-5" alt="Icone cosmetique" loading="lazy" height="44" width="39">
      </picture>
      <picture>
        <source srcset="/assets/images/home/icon/cosmetique_shadow.webp?v=2.3" type="image/webp">
        <source srcset="/assets/images/home/icon/cosmetique_shadow.png?v=2.3" type="image/png">
        <img src="/assets/images/home/icon/cosmetique_shadow.webp?v=2.3" alt="Icone ombre cosmetique" loading="lazy" height="51" width="46">
      </picture>
    </div>
    <div class="icon-3">
      <picture>
        <source srcset="/assets/images/home/icon/entretien.webp?v=2.4" type="image/webp">
        <source srcset="/assets/images/home/icon/entretien.png?v=2.4" type="image/png">
        <img src="/assets/images/home/icon/entretien.webp?v=2.4" class="gravity gravity-2" alt="Icone entretien" loading="lazy" height="28" width="32">
      </picture>
      <picture>
        <source srcset="/assets/images/home/icon/entretien_shadow.webp?v=2.3" type="image/webp">
        <source srcset="/assets/images/home/icon/entretien_shadow.png?v=2.3" type="image/png">
        <img src="/assets/images/home/icon/entretien_shadow.webp?v=2.3" alt="Icone ombre entretien" loading="lazy" height="37" width="41">
      </picture>
    </div>
    <div class="icon-4">
      <picture>
        <source srcset="/assets/images/home/icon/jardinage.webp?v=2.3" type="image/webp">
        <source srcset="/assets/images/home/icon/jardinage.png?v=2.3" type="image/png">
        <img src="/assets/images/home/icon/jardinage.webp?v=2.3" class="gravity gravity-3" alt="Icone jardinage" loading="lazy" height="19" width="27">
      </picture>
      <picture>
        <source srcset="/assets/images/home/icon/jardinage_shadow.webp?v=2.3" type="image/webp">
        <source srcset="/assets/images/home/icon/jardinage_shadow.png?v=2.3" type="image/png">
        <img src="/assets/images/home/icon/jardinage_shadow.webp?v=2.3" alt="Icone ombre jardinage" loading="lazy" height="23" width="29">
      </picture>
    </div>
    <div class="icon-5">
      <picture>
        <source srcset="/assets/images/home/icon/bricolage.webp?v=2.3" type="image/webp">
        <source srcset="/assets/images/home/icon/bricolage.png?v=2.3" type="image/png">
        <img src="/assets/images/home/icon/bricolage.webp?v=2.3" class="gravity gravity-4" alt="Icone bricolage" loading="lazy" height="30" width="27">
      </picture>
      <picture>
        <source srcset="/assets/images/home/icon/bricolage_shadow.webp?v=2.3" type="image/webp">
        <source srcset="/assets/images/home/icon/bricolage_shadow.png?v=2.3" type="image/png">
        <img src="/assets/images/home/icon/bricolage_shadow.webp?v=2.3" alt="Icone ombre bricolage" loading="lazy" height="50" width="39">
      </picture>
    </div>

    <h1 class="second-row">
      Découvre & crée<br/>
      tes recettes fait maison
    </h1>
    <p class="third-row">
      Il est temps de centraliser les recettes fait maison en un seul et même endroit !
    </p>
    <div class="action-row action-link">
      <a [routerLink]="'/recette/liste/cosmetique'">
        <picture>
          <source srcset="/assets/images/home/cosmetic.webp?v=3" type="image/webp">
          <source srcset="/assets/images/home/cosmetic.png?v=3" type="image/png">
          <img src="/assets/images/home/cosmetic.webp?v=3" width="195" height="83"
               alt="Image cosmetique">
        </picture>
      </a>
      <a [routerLink]="'/recette/liste/entretien'">
        <picture>
          <source srcset="/assets/images/home/entretien.webp?v=4" type="image/webp">
          <source srcset="/assets/images/home/entretien.png?v=4" type="image/png">
          <img src="/assets/images/home/entretien.webp?v=4" width="195" height="83"
               alt="Image entretien">
        </picture>
      </a>
    </div>
    <div class="action-row">
      ou <ng-container *ngIf="!user">inscris-toi et</ng-container>
      <a class="btn-liquid-main" [routerLink]="'/recette/creation'" [queryParams]="{step : 1}" *ngIf="user">
        <span class="mas"> Créer ta recette</span>
        <button #anim2 type="button" name="Hover" (mouseenter)="removeClass(anim2)" class="no-anim"> Créer ta recette</button>
      </a>
      <div class="btn-liquid-main" (click)="openModal('new-recipe-log-in')" *ngIf="!user">
        <span class="mas"> Créer ta recette</span>
        <button #anim3 type="button" name="Hover" (mouseenter)="removeClass(anim3)" class="no-anim"> Créer ta recette</button>
      </div>
    </div>
  </div>

  <div class="container recipes">

    <div class="bloc-title">
      <div class="title">
        <img src="/assets/images/home/icon-cosmetique.svg?v=3" alt="Icon cosmetique" width="37" height="37">
        <div class="text">
          <span class="sub-title">Les recettes</span>
          <h2>Cosmétique</h2>
        </div>
      </div>
      <a [routerLink]="'/recette/liste/entretien'"
         [queryParams]="{domain : 'entretien', properties : 'star', direction: 'desc'}" class="link">VOIR TOUT</a>
    </div>


    <app-recipe-card-component class="list" [currentRecipes]="recipesCosmetics"
                               [currentUser]="this.user"></app-recipe-card-component>

    <a [routerLink]="'/recette/liste/entretien'"
       [queryParams]="{domain : 'entretien', properties : 'star', direction: 'desc'}" class="link mobile">VOIR TOUT</a>

  </div>

  <div class="container recipes">

    <div class="bloc-title">
      <div class="title">
        <img src="/assets/images/home/icon-entretien.svg?v=3" alt="Icon entretien" width="44" height="31">
        <div class="text">
          <span class="sub-title">Les recettes</span>
          <h2>Entretien</h2>
        </div>
      </div>
      <a [routerLink]="'/recette/liste/entretien'"
         [queryParams]="{domain : 'entretien', properties : 'star', direction: 'desc'}" class="link">VOIR TOUT</a>
    </div>

    <app-recipe-card-component class="list" [currentRecipes]="recipesEntretiens"
                               [currentUser]="this.user"></app-recipe-card-component>

    <a [routerLink]="'/recette/liste/entretien'"
       [queryParams]="{domain : 'entretien', properties : 'star', direction: 'desc'}" class="link mobile">VOIR TOUT</a>

  </div>


  <div class="users" *ngIf="users.length > 0">
    <div class="container">
      <div class="title">
        <h3>Les profils du moment</h3>
        <img src="/assets/images/home/title-users.svg" alt="Background title users" loading="lazy" width="132" height="92">
      </div>

      <app-user-card-component class="list" [currentUsers]="users"></app-user-card-component>
    </div>
    <img src="/assets/images/home/bg-users.svg" class="bg" alt="Background block users" width="1919" height="557">
  </div>

  <div class="for-who">
    <div class="left">
      <div class="bloc-text">
        <img src="/assets/images/home/Interrogation.png?v=2.3" loading="lazy" class="interrogation" width="92" height="66"
             alt="Par qui, pour qui ?"/>

        <h2>par qui, Pour qui ? </h2>
        <p>Chacune des recettes est créée par nos utilisateurs (oui toi aussi!) qui décident de partager son
          savoir-faire
          afin de rendre le fait maison accessible à tous :)</p>
        <div class="advantage">
          LES BIEN FAITS du fait maison :
          <img src="/assets/images/home/natural.svg?v=2.3" loading="lazy" alt="naturel" width="16" height="16"/>
          <img src="/assets/images/home/ecologique.svg?v=2.3" loading="lazy" alt="ecologique" width="15" height="15"/>
          <img src="/assets/images/home/diy.svg?v=2.3" loading="lazy" alt="diy" width="19" height="17"/>
        </div>

        <h2>Les + de tooda <img src="/assets/images/home/seau.svg?v=2.3" loading="lazy" alt="seau" width="31" height="25"/></h2>
        <p>Des créations de recette détaillées, avec une liste
          des ustensiles et ingrédients, les étapes de
          fabrication, des tags précis, un espace commentaire pour faciliter les échanges entre la communauté!</p>

        <p class="save-comment">Enregistre, commente & partage tes recettes / artistes favoris</p>
      </div>


    </div>

    <div class="right">
      <picture>
        <source srcset="/assets/images/home/bg-home-two.webp?v=2.3" type="image/webp">
        <source srcset="/assets/images/home/bg-home-two.png?v=2.3" type="image/png">
        <img src="/assets/images/home/bg-home-two.webp" class="home-picture-for-who" loading="lazy" width="1086" height="519"
             alt="Accueil image pour qui">
      </picture>
    </div>
    <div class="arrow" (click)="scrollToElement(pourvoirCommunaute)"><</div>

  </div>

  <div class="blogs" *ngIf="blogs.length > 0">
    <div class="container">
      <h3>
        le <span class="big">blog</span> de <span class="big">Tooda</span>
      </h3>

      <app-blog-card-home-component class="list" [currentBlogs]="blogs"></app-blog-card-home-component>

      <a [routerLink]="'/blog/liste'" class="btn btn-blog-raised">Accéder au blog</a>
    </div>
  </div>

  <div class="power-community" #pourvoirCommunaute>
    <img src="/assets/images/home/tooda_logo.svg?v=2.3" loading="lazy" alt="Logo tooda transparent" class="tooda-logo" width="1432" height="505">

    <div class="user it-s-you">
      <p>C'est vous</p>
      <img src="/assets/images/home/arrow.svg?v=2.3" class="arrow-power" loading="lazy" alt="Fleche c'est vous" width="189" height="197">
    </div>


    <p class="user name-user-1 gravity gravity-1">Sarah</p>
    <picture>
      <source srcset="/assets/images/home/sarah.webp?v=2.3" type="image/webp">
      <source srcset="/assets/images/home/sarah.png?v=2.3" type="image/png">
      <img src="/assets/images/home/sarah.webp?v=2.3" class="user user-1 gravity gravity-1" loading="lazy" width="209" height="209"
           alt="Utilisateur sarah communauté Tooda recettes fait maison">
    </picture>

    <p class="user name-user-2 gravity gravity-2">Asya</p>
    <picture>
      <source srcset="/assets/images/home/asya.webp?v=2.3" type="image/webp">
      <source srcset="/assets/images/home/asya.png?v=2.3" type="image/png">
      <img src="/assets/images/home/asya.webp?v=2.3" class="user user-2 gravity gravity-2" loading="lazy" width="278" height="278"
           alt="Utilisateur asya communauté Tooda recettes fait maison">
    </picture>

    <p class="user name-user-3 gravity gravity-3">Paul</p>
    <picture>
      <source srcset="/assets/images/home/paul.webp?v=2.3" type="image/webp">
      <source srcset="/assets/images/home/paul.png?v=2.3" type="image/png">
      <img src="/assets/images/home/paul.webp?v=2.3" class="user user-3 gravity gravity-3" loading="lazy" height="209" width="209"
           alt="Utilisateur paul communauté tooda recettes fait maison">
    </picture>

    <p class="user name-user-4 gravity gravity-4">Damien</p>
    <picture>
      <source srcset="/assets/images/home/damien.webp?v=2.3" type="image/webp">
      <source srcset="/assets/images/home/damien.png?v=2.3" type="image/png">
      <img src="/assets/images/home/damien.webp?v=2.3" class="user user-4 gravity gravity-4" loading="lazy" width="174" height="174"
           alt="Utilisateur damien communauté tooda recettes fait maison">
    </picture>

    <p class="user name-user-5 gravity gravity-5">Li</p>
    <picture>
      <source srcset="/assets/images/home/li.webp?v=2.3" type="image/webp">
      <source srcset="/assets/images/home/li.png?v=2.3" type="image/png">
      <img src="/assets/images/home/li.webp?v=2.3" class="user user-5 gravity gravity-5" loading="lazy" height="278" width="278"
           alt="Utilisateur li communauté tooda recettes fait maison">
    </picture>

    <div class="bloc-text">
      <h3>Le pouvoir <br/>de la communauté</h3>
      <p>Chacune des recettes est le fruit de notre communauté qui décide de partager son savoir faire en publiant une
        recette. Pour tout le monde bien évidement ;) </p>
    </div>

  </div>

<!--  <div class="home-menu">-->
<!--    <p>Découvre Tooda : </p>-->
<!--    <a href=""></a>-->
<!--  </div>-->
</div>
